import apiSlice from './apiSlice';

const apiSignUpOrganizationSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getsignUpOrganization: builder.query({
      /* eslint-disable camelcase */
      query: ({ token, user_id }) => ({
        url: `/invite/complete-registration/${user_id}-${token}`,
        method: 'GET',
      }),
      invalidatesTags: ['invite'],
    }),
    SignUpOrganization: builder.mutation({
      query: ({ token, user_id, payload }) => ({
        url: `/invite/complete-registration/${user_id}-${token}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['invite'],
    }),
  }),
});

export const { useGetsignUpOrganizationQuery, useSignUpOrganizationMutation } = apiSignUpOrganizationSlice;

export default apiSignUpOrganizationSlice;
